import * as XLSX from 'xlsx-js-style';

const exportToCSV = (filename, rows, styleCell) => {
    const worksheet = XLSX.utils.aoa_to_sheet(rows);
    if (styleCell) {
        rows.forEach((row, r) => row.forEach((_, c) => {
            const cell = worksheet[XLSX.utils.encode_cell({r, c})];
            const style = styleCell(r, c);
            if (cell && style) cell.s = style;
        }));
    }
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    XLSX.writeFile(workbook, filename.replace(/\.csv$/i, ".xlsx"));
}

export default exportToCSV;